
// components/PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const currentUserEmail = localStorage.getItem('userEmail');
  const isAdmin = currentUserEmail === 'seifeddinejamai8@gmail.com';

  return isAdmin ? children : <Navigate to="./" />;
};

export default PrivateRoute;